import {ApplicationStoreType} from 'desktop/store';

import {SpecialOfferItemType} from '../../reducers/quoteInfo/quoteInfoType';

/**
 * Get cart share id.
 *
 * @param {ApplicationStoreType} store - Application store type.
 * @returns {string} - Cart share id.
 */
export const getCartShareId = (store: ApplicationStoreType): string | null =>
    store.cart?.quoteInfo?.shareId ?? null;

/**
 * Get quote specialOffers
 */
export const getQuoteSpecialOffers = (
    store: ApplicationStoreType,
): Array<SpecialOfferItemType> | null => {
    return store.cart.quoteInfo.specialOffers;
};
